import { render, staticRenderFns } from "./Jidian.vue?vue&type=template&id=134003fa&scoped=true&"
import script from "./Jidian.vue?vue&type=script&lang=ts&"
export * from "./Jidian.vue?vue&type=script&lang=ts&"
import style0 from "./Jidian.vue?vue&type=style&index=0&id=134003fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134003fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
